import * as Yup from "yup";

/**
 * mediaSchema
 * Validação Yup para o formulário de Mídia.
 */
export const mediaSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, "Nome muito curto")
        .required("O nome é obrigatório"),
    imageUrl: Yup.string()
        .url("URL inválida")
        .required("A imagem é obrigatória"),
    startDate: Yup.string()
        .matches(/^\d{4}-\d{2}-\d{2}$/, "Data inválida")
        .required("A data de início é obrigatória"),
    endDate: Yup.string()
        .matches(/^\d{4}-\d{2}-\d{2}$/, "Data inválida")
        .required("A data de fim é obrigatória"),
    status: Yup.string()
        .oneOf(["active", "inactive"])
        .default("active"),
});
